import { AppBar, Button, ButtonBase, Typography } from '@material-ui/core';
import { BLACK, WHITE_50 } from 'components/chatWidget/assets/theme/colors';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import dinogoBigDealLogo from '../../../../src/assets/images/image/ic_dinogo_big_deal.png';
import { Row } from '../../../components/chatWidget/common/Elements';
import { HEADER_HEIGHT } from '../../../constants';
import { getAccountInfo } from '../../system/systemAction';

const Header = (props) => {
  return (
    <AppBar
      style={{
        height: HEADER_HEIGHT,
        backgroundColor: WHITE_50,
        borderRadius: 0,
        zIndex: 1000,
        boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.25)',
        position: 'sticky',
      }}>
      <Row style={{ height: '100%', padding: '0px 16px 0px 50px' }}>
        <ButtonBase
          disableTouchRipple
          // onClick={() =>
          //   dispatch(goToAction({ pathname: '/' }))
          // }
        >
          {/* <DinogoLogo style={{ width: 180, height: 180 }} /> */}
          <img
            src={dinogoBigDealLogo}
            style={{ width: 180 }}
            alt='dinogo-logo'
          />
        </ButtonBase>
        <Row
          style={{
            marginLeft: '24px',
            transition: 'width 0.3s',
            justifyContent: 'center',
          }}
        />
        <Row
          style={{
            flex: 1,
            justifyContent: 'flex-end',
            marginRight: 24,
            marginTop: 5,
          }}>
          <Button color='secondary' style={{ marginRight: 20 }}>
            <Typography
              variant='body2'
              style={{ fontWeight: 700, color: BLACK }}>
              <FormattedMessage id='IDS_HEADER_HOME_PAGE' />
            </Typography>
          </Button>
          <Button color='secondary' style={{ marginRight: 20 }}>
            <Typography
              variant='body2'
              style={{ fontWeight: 700, color: BLACK }}>
              <FormattedMessage id='IDS_HEADER_SERVICE' />
            </Typography>
          </Button>
          <Button color='secondary' style={{ marginRight: 20 }}>
            <Typography
              variant='body2'
              style={{ fontWeight: 700, color: BLACK }}>
              <FormattedMessage id='IDS_HEADER_FEATURE' />
            </Typography>
          </Button>
          <Button color='secondary' style={{ marginRight: 20 }}>
            <Typography
              variant='body2'
              style={{ fontWeight: 700, color: BLACK }}>
              <FormattedMessage id='IDS_HEADER_PROMOTION' />
            </Typography>
          </Button>
          <Button color='secondary' style={{ marginRight: 20 }}>
            <Typography
              variant='body2'
              style={{ fontWeight: 700, color: BLACK }}>
              <FormattedMessage id='IDS_HEADER_DOWNLOAD' />
            </Typography>
          </Button>
        </Row>
      </Row>
    </AppBar>
  );
};
export default connect(
  (state) => ({
    // isLoading: state.system.isLoading
  }),
  { getAccountInfo }
)(withRouter(Header));
